export default "__VITE_ASSET__BSOLt6$O__"